import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    class: "siteSearch-hit",
    "data-hit": "page"
};
const _hoisted_2 = {
    key: 0,
    class: "imageWrapper"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "textWrapper" };
const _hoisted_5 = { class: "cardTitle" };
const _hoisted_6 = ["href", "innerHTML"];
const _hoisted_7 = ["href"];
const _hoisted_8 = ["innerHTML"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'Page',
    props: {
        document: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            var _a, _b;
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                (_ctx.document.thumbnail_url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("img", {
                            src: _ctx.document.thumbnail_url,
                            alt: ""
                        }, null, 8, _hoisted_3)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h4", _hoisted_5, [
                        _createElementVNode("a", {
                            href: _ctx.document.url,
                            innerHTML: ((_a = _ctx.document._formatted) === null || _a === void 0 ? void 0 : _a.title) || _ctx.document.title
                        }, null, 8, _hoisted_6)
                    ]),
                    _createElementVNode("a", {
                        href: _ctx.document.url,
                        class: "link"
                    }, _toDisplayString(_ctx.document.url), 9, _hoisted_7),
                    _createElementVNode("div", {
                        class: "excerpt",
                        innerHTML: ((_b = _ctx.document._formatted) === null || _b === void 0 ? void 0 : _b.excerpt) || _ctx.document.excerpt
                    }, null, 8, _hoisted_8)
                ])
            ]));
        };
    }
});
